import React__default from 'react';
import FormSelect from './FormSelect.js';
import { c as createFilter } from '../../../../../../node_modules/.pnpm/react-select@5.8.0_@babel_core@7.18.10_@types_react@19.0.1_react-dom@19.0.0_react@19.0.0/node_modules/react-select/dist/Select-49a62830.esm.js';

const SelectWrapper = (props) => {
    const { config: { key, externalDataOptions, label, options: selectOptions, placeholder, boldLabel, showErrorIcon, noMenuPortal, isSearchable = true, disabled }, keySuffix, externalData } = props;
    const options = selectOptions ||
        (externalDataOptions && externalData && externalData[externalDataOptions]
            ? externalData[externalDataOptions]
            : []);
    return (React__default.createElement(FormSelect, { name: `${key}${keySuffix || ''}`, options: options, getLabel: (option) => (option ? option.description : ''), getValue: (option) => (option ? option.code : ''), selectedOption: (value) => options.find(option => option.code === value), getCurrentValue: (option) => option.code, label: label, boldLabel: boldLabel, placeholder: placeholder, showErrors: true, isSearchable: isSearchable, filterOption: createFilter({
            matchFrom: 'any',
            stringify: (option) => option.data.description
        }), showErrorIcon: showErrorIcon, noMenuPortal: noMenuPortal, disabled: disabled }));
};

export { SelectWrapper as default };
//# sourceMappingURL=SelectWrapper.js.map
